// 客人端多語言 — 中文為 key，缺譯 fallback 原文（與原生 App String Catalog 同哲學）
// 範圍：僅顧客面頁面（訂位 / QR 點餐 / 結帳結果）。店家端維持繁中（原生 App 已雙語）。
// 語言決定順序：localStorage 手動切換 > navigator.language > zh
// see architecture.md#L580

const STORAGE_KEY = 'pos-customer-lang';

const EN = {
  // ── 共用 ──
  '載入中…': 'Loading…',
  '送出中…': 'Submitting…',
  '網址格式錯誤': 'Invalid URL',
  '無法載入店家資訊': "Couldn't load shop info",
  '送出失敗，請重試': 'Submission failed, please retry',
  '店家': 'Shop',
  '今天': 'Today',
  '明天': 'Tomorrow',
  '週日': 'Sun', '週一': 'Mon', '週二': 'Tue', '週三': 'Wed', '週四': 'Thu', '週五': 'Fri', '週六': 'Sat',

  // ── 訂位頁 ──
  '線上訂位': 'Online Booking',
  '日期': 'Date',
  '時段': 'Time',
  '檢查中…': 'Checking…',
  '店家未設座位數，無法擋滿桌': "Shop hasn't set seat capacity; full slots can't be blocked",
  '此時段已滿': 'This slot is full',
  '剩 {n} 位': '{n} seats left',
  '滿': 'Full',
  '人數': 'Party size',
  '{n} 位': '{n} ppl',
  '姓名': 'Name',
  '電話': 'Phone',
  '備註（選填）': 'Note (optional)',
  '確認訂位': 'Confirm booking',
  '訂位已確認': 'Booking confirmed',
  '時間': 'Time',
  '如需更改或取消，請直接致電店家': 'To change or cancel, please call the shop directly',
  '請填寫姓名': 'Please enter your name',
  '電話格式錯誤': 'Invalid phone number',
  '請選日期與時段': 'Please pick a date and time',

  // ── QR 點餐 ──
  '線上點餐': 'Order Online',
  '桌號': 'Table',
  '加入': 'Add',
  '已加入': 'Added',
  '購物車': 'Cart',
  '項': 'items',
  '前往結帳': 'Checkout',
  '菜單載入失敗': "Couldn't load menu",
  '目前沒有供應中的品項': 'No items available right now',
  '此店家尚未開放線上點餐': "This shop hasn't enabled online ordering",

  // ── 結帳 ──
  '確認訂單': 'Confirm order',
  '訂單明細': 'Order details',
  '小計': 'Subtotal',
  '合計': 'Total',
  '備註': 'Note',
  '送出訂單': 'Place order',
  '訂單已送出': 'Order placed',
  '訂單編號': 'Order no.',
  '請稍候，店員確認後開始製作': 'Please wait — staff will confirm and start preparing',
  '返回菜單': 'Back to menu',
  '購物車是空的': 'Your cart is empty',
  '數量': 'Qty',
  '移除': 'Remove',

  // ── QR 點餐（menu 頁實際字串）──
  '網址格式錯誤：請從店家 QR 掃碼進入': 'Invalid URL — please scan the QR code at your table',
  '確定清空購物車嗎？': 'Clear the cart?',
  '全部': 'All',
  '目前沒有品項': 'No items available',
  '主廚推薦': "Chef's pick",
  '推薦': 'Popular',
  '共': '',
  '清空購物車': 'Clear cart',
  '清空': 'Clear',
  '前往送單': 'Review & send order',
  '掃描點餐 · 店員確認後準備': 'Scan to order · prepared after staff confirms',

  // ── 結帳頁 ──
  '載入失敗': 'Failed to load',
  '送單失敗，請稍後再試': "Couldn't send order, please retry",
  '返回菜單': 'Back to menu',
  '總計': 'Total',
  '例：少冰、不加糖、等朋友到再上': 'e.g. less ice, no sugar, serve when everyone arrives',
  '送單後可能無法修改，如有客製需求請寫清楚': "Orders may not be editable after sending — please note any customizations clearly",
  '送單中…': 'Sending…',
  '送出訂單': 'Send order',
  '訂單送出成功': 'Order sent!',
  '店員會盡快準備': 'Staff will prepare it shortly',
  '餐點會送到': 'Your food will be served at table',
  '號桌': '',
  '返回菜單繼續點': 'Back to menu to order more',

  // ── 付款結果 ──
  '付款成功': 'Payment successful',
  '付款完成': 'Payment complete',
  '我們已收到您的付款，餐點準備中。': "We've received your payment. Your food is being prepared.",
  '付款確認中': 'Confirming payment',
  '金流端尚未回覆最終結果，請稍候並重新整理；若超過 5 分鐘仍未完成，請洽店員。': "The payment provider hasn't returned a final result. Please wait and refresh; if it takes over 5 minutes, ask the staff.",
  '付款失敗': 'Payment failed',
  '這筆付款沒有成功，您沒有被扣款。請回到結帳頁重試，或改用其他付款方式。': "This payment didn't go through and you weren't charged. Please retry from checkout or use another method.",
  '已取消付款': 'Payment cancelled',
  '您已取消這次付款，訂單尚未付款。': 'You cancelled this payment. The order remains unpaid.',
  '發生錯誤': 'Something went wrong',
  '付款流程發生異常，若已扣款請保留畫面並洽店員核對。': 'The payment flow hit an error. If you were charged, keep this screen and ask the staff to verify.',
  '訂單編號': 'Order no.',
  '代碼': 'code',
  '回訂單清單': 'Back to orders',
  '重新結帳': 'Retry checkout',
  '付款處理中': 'Processing payment',
  '返回': 'Back',
  // ── 訂位管理頁 / 政策 ──
  'Email（選填，收訂位確認與前一天提醒）': 'Email (optional — get confirmation & day-before reminder)',
  'Email 格式錯誤': 'Invalid email',
  '訂位保留 10 分鐘，逾時恕不保留座位': 'Tables are held for 10 minutes past the reserved time',
  '管理訂位（確認出席 / 取消）': 'Manage booking (confirm / cancel)',
  '確認信已寄到你的 Email，內含管理連結': 'A confirmation email with the manage link has been sent to you',
  '建議截圖保存此頁，以便需要時取消': 'Screenshot this page in case you need to cancel later',
  '連結無效': 'Invalid link',
  '連結已過期': 'This link has expired',
  '如需協助請直接致電店家': 'For help, please call the shop directly',
  '確定取消這筆訂位嗎？': 'Cancel this booking?',
  '確定取消？再按一次': 'Sure? Tap again to cancel',
  '操作失敗，請重試': 'Action failed, please retry',
  '我的訂位': 'My booking',
  '訂位已取消': 'Booking cancelled',
  '已確認出席，到時見！': "Attendance confirmed — see you there!",
  '確認出席': "I'm coming",
  '取消訂位': 'Cancel booking',
  '待確認': 'Pending',
  '已確認': 'Confirmed',
  '已完成': 'Completed',
  '未到': 'No-show',
  '已就座': 'Seated',
  '狀態': 'Status',
};

let _lang = null;

/** 目前語言：'zh' | 'en' */
export function lang() {
  if (_lang) return _lang;
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved === 'zh' || saved === 'en') {
    _lang = saved;
  } else {
    _lang = (navigator.language || 'zh').toLowerCase().startsWith('zh') ? 'zh' : 'en';
  }
  return _lang;
}

export function setLang(next) {
  _lang = next === 'en' ? 'en' : 'zh';
  localStorage.setItem(STORAGE_KEY, _lang);
}

/**
 * 翻譯：中文 key → 目前語言。支援 {n} 佔位：t('剩 {n} 位', { n: 3 })
 * 缺譯 fallback 中文原文（永不顯示 key 錯誤）。
 */
export function t(zh, params) {
  let s = lang() === 'en' ? (EN[zh] ?? zh) : zh;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      s = s.replaceAll(`{${k}}`, String(v));
    }
  }
  return s;
}

/** 語言切換鈕 HTML（客人端頁首用）＋事件掛法：呼叫端 querySelector 後 addEventListener */
export function langToggleHtml() {
  return `<button type="button" class="lang-toggle" data-act="lang-toggle">${lang() === 'zh' ? 'EN' : '中'}</button>`;
}

export const LANG_TOGGLE_CSS = `
  .lang-toggle { position: absolute; top: 1rem; right: 1rem; padding: 0.3rem 0.7rem;
    border: 1px solid #ddd; background: #fff; border-radius: 999px; font-size: 0.85rem;
    cursor: pointer; color: #555; }
`;
